const CustomerIcon = ({ ...props }) => {
  const color = props?.color || "#05383f";
  const size = props?.size || "30px";
  const fileSrc = "/public/icon/customer.svg";
  return (
    <div
      style={{
        width: size,
        height: size,
        marginLeft: "2px",
        display: "inline-block",
        verticalAlign: "middle",
        backgroundColor: color,
        maskImage: "url(" + fileSrc + ")",
        maskSize: "contain",
        WebkitMaskImage: "url(" + fileSrc + ")",
        WebkitMaskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        maskRepeat: "no-repeat",
      }}
    />
  );
};

export default CustomerIcon;
